import {applySpec, constant, find, flow, get, ifElse, isUndefined} from '@yandex-delivery/utils'
import type {UserFeedback} from 'src/api/types'

import {isFeedbackAction} from '../../utils'

export const toUserFeedback = flow(
  get('actions'),
  find(isFeedbackAction),
  get('last_feedback'),
  ifElse(
    isUndefined,
    constant(undefined),
    applySpec<UserFeedback>({
      score: get('score'),
      comment: get('comment'),
      reasonIDs: get('reason_ids'),
    }),
  ),
)
